"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kTimer = Symbol('InternalTimer');
function internalSetTimeout(fn, delay) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return setTimeout(fn, delay, args);
}
exports.internalSetTimeout = internalSetTimeout;
function internalClearTimeout(timer) {
    return clearTimeout(timer);
}
exports.internalClearTimeout = internalClearTimeout;
function internalSetInterval(fn, delay) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return setInterval(fn, delay, args);
}
exports.internalSetInterval = internalSetInterval;
function internalClearInterval(timer) {
    return clearInterval(timer);
}
exports.internalClearInterval = internalClearInterval;
function internalSetImmediate(fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return setImmediate(fn, args);
}
exports.internalSetImmediate = internalSetImmediate;
function internalClearImmediate(timer) {
    return clearImmediate(timer);
}
exports.internalClearImmediate = internalClearImmediate;
